import axios from 'axios';
import {Message} from 'element-ui';

var querystring = require("querystring")
var crypto = require("crypto")

var environment = "pro"

var bug = true

class Util {

  async get_field(menu, project) {

    return await this.post("admin", "get_field", {id: menu, project: project})

  }

  async get_field_module(module, project) {
    return await this.post("admin", "get_field_module", {module: module})

  }


  config() {
    if (location.hostname == "127.0.0.1" || location.hostname == "localhost") {
      environment = "test"
    }


    var server = ""
    if (environment == "test") {
      server = "http://127.0.0.1:4800"
      bug = true
    } else {

      if (location.hostname.indexOf("sumou.fun") != - 1) {
        server = "https://server.sumou.fun"
      } else {
        server = "https://server.jlxz.shop"
      }
      bug = false
    }
    var loginfund = "usercodelogin"
    window.isagent = true
    if (location.hostname == "jlxz.shop" || location.hostname == 'www.jlxz.shop' || location.hostname == "sumou.fun" || location.hostname == 'www.sumou.fun' || location.hostname == '127.0.0.1') { //
      window.isagent = false
      loginfund = "code_login"
    }
    return {
      environment: environment,
      static: "https://file.sumou.fun",
      server: server,
      loginfund: loginfund,
      domain: location.hostname.replace('www.', ''),
    }
  }

  async post(se, fun, data, not, noreload, notlogin) {

    this.config()
    var loding = document.getElementsByClassName("loading")

    if (loding.length > 0 && noreload !== false) {
      loding[0].style.display = "flex"
    }

    if (!data) {
      data = {}
    }

    let _this = this

    data.sg = new Date().getTime().toString(8)
    data.sgin = crypto.createHash('md5').update(JSON.stringify(data)).digest('hex');
    let key = this.randomWord(16, 16)
    let sum = parseInt(Math.random() * (20 - 10 + 1) + 10, 10)
    let sgdata = this.randomWord(sum, sum)
    let info = JSON.stringify(data)
    return new Promise((r, e) => {
      var request_data = data
      if (bug) {
        console.log(data._ + " " + se + " " + fun + " request data --->", JSON.parse(JSON.stringify(data)))
        request_data.bug = true
      } else {

        request_data = {_: Buffer.from(sum.toString(8) + sgdata + key + this.encryption(info, key), 'binary')}
      }
      request_data._ = request_data._

      axios.post(this.config().server + "/" + se + "/" + fun, request_data, {
        timeout: 50000,
        headers: {
          sgin: data.sgin,
          proth: "WEB",
          module: _this.get_cookie("module") || "public",
          server: _this.get_cookie("server") || "server",
          modulenames: encodeURIComponent(_this.get_cookie("table_name") || ""),
          identifying: _this.get_cookie("identifying") || "",
          authorization: _this.get_cookie("AUTH") || "",
        }
      })
        .then(function (response) {
          if (loding.length > 0 && fun != "ping") {
            loding[0].style.display = "none"
          }
          try {
            let res_data = JSON.parse(_this.decryption(response.data.substring(18, response.data.length), response.data.substring(2, 18)))
            //打开debug 大于返回内容
            if (bug) {
              console.log(se + " " + fun + "  response data <---", res_data)
            }

            if (res_data.sgin != data.sgin || res_data.requestid != data.sg) { //签名验证不通过或者请求ID对不上则不返回内容
              r(false)
              return
            }
            if (res_data.code != 200) { //签名验证不通过
              if (!not) {
                _this.error(res_data.message)
              }
              r(false)
              return
            } else {
              r(res_data.data)
            }
          } catch (e) {
            console.log(e)
          }
        })
        .catch(function (error) {
          var {response} = error
          if (loding.length > 0) {
            loding[0].style.display = "none"
          }
          if (error.response.status == 402 && !not) { //登录过期
            if (location.href.indexOf("adminindex") != - 1 || location.href.indexOf("adminhome") != - 1) {
              location.href = "/#/adminlogin"
            } else {
              location.href = "/#/"
            }
          } else if (error.response.status == 500 && !not) {
            var res_data = JSON.parse(_this.decryption(response.data.substring(18, response.data.length), response.data.substring(2, 18)))
            _this.error("服务器繁忙" + res_data.message)

          } else {
            if (!notlogin) {
              _this.error("服务器繁忙")
            }
          }
          r(false)
        });
    })
  }

  setCookie(name, val, min) {
    var now = new Date();
    //设置时间
    now.setMinutes(now.getMinutes() + min)
    //设置Cookie
    document.cookie = name + '=' + val + ';expires=' + now.toUTCString()
  }

  async get(se, fun, data) {

    axios.get(this.config().server + se + "/" + fun + "?" + querystring.stringify(data), request_data, {
      headers: {}
    })
      .then(function (response) {
        r(response.data)
      })
      .catch(function (error) {
        r(false)
      });

  }


  async get_no(se, fun, data) {

    return new Promise((r, e) => {
      // console.log(data)
      var request_data = data

      // console.log(this.config().server + "/" + se + "/" + fun + "?" + querystring.stringify(data))
      axios.get(this.config().server + "/" + se + "/" + fun + "?" + querystring.stringify(data), request_data, {
        headers: {
          sgin: "", authorization: ""
        }
      })
        .then(function (response) {

          try {

            r(response.data)
          } catch (e) {
            console.log(e)
          }
        })
        .catch(function (error) {
          r(false)
        });

    })
  }

  encryption(data, key, iv) {
    var cipherChunks = [];
    var cipher = crypto.createCipheriv('aes-128-cbc', key, "0123456789abcdef");
    cipher.setAutoPadding(true);
    cipherChunks.push(cipher.update(data, 'utf8', 'base64'));
    cipherChunks.push(cipher.final('base64'));
    return cipherChunks.join('');
  }


  decryption(data, key, iv) {
    var cipherChunks = [];
    var decipher = crypto.createDecipheriv('aes-128-cbc', key || "Q85Wc34a6W945Wcf", iv || "0123456789abcdef");
    decipher.setAutoPadding(true);
    cipherChunks.push(decipher.update(data, 'base64', 'utf8'));
    cipherChunks.push(decipher.final('utf8'));
    return cipherChunks.join('');
  }

  randomWord(min, max) {
    var str = "", range = min,
      arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    // 随机产生
    range = Math.round(Math.random() * (max - min)) + min;
    for (var i = 0; i < range; i ++) {
      var pos = Math.round(Math.random() * (arr.length - 1));
      str += arr[pos];
    }
    return str;
  }


  get_cookie(name) {
    var ck = document.cookie
    var array = ck.split(";")

    for (var i = 0; i < array.length; i ++) {
      var obj = array[i];

      var ck = obj.split("=")
      if (ck[0].indexOf(name) != - 1) {
        return ck[1]
      }

    }

  }

  getCookie(cookieName) {
    const strCookie = document.cookie
    const cookieList = strCookie.split(';')

    for (let i = 0; i < cookieList.length; i ++) {
      const arr = cookieList[i].split('=')
      if (cookieName === arr[0].trim()) {
        return arr[1]
      }
    }

    return ''
  }

  formatDateTime(obj, time) {
    var date;
    if (time) {
      date = new Date(time);
    } else {
      date = new Date()
    }
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    minute = minute < 10 ? ('0' + minute) : minute;
    var second = date.getSeconds();
    second = second < 10 ? ('0' + second) : second;
    if (obj == 1) {
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    }
    if (obj == 2) {
      return y + '-' + m + '-' + d;
    }
    if (obj == 3) {
      return h + ':' + minute + ':' + second;
    }
    if (obj == 4) {
      return date.getTime();
    }
    if (obj == 5) {
      return minute + ':' + second;
    }
    if (obj == 6) {
      return h + ':' + minute;
    }
    if (obj == 7) {
      return "" + y + m + d + h + minute + second + date.getMilliseconds();
    }
    if (obj == 8) {
      return y + '年' + m + '月' + d + '日';
    }
    if (obj == 9) {
      var day = date.getDay();
      var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
      var week = weeks[day];
      return week;

    }
  }

  error(str) {
    Message.error(str)
    return
  }

  alert(str) {
    Message.success(str)
    return
  }

  randomWord(min, max) {
    var str = "", range = min,
      arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    // 随机产生
    range = Math.round(Math.random() * (max - min)) + min;
    for (var i = 0; i < range; i ++) {
      var pos = Math.round(Math.random() * (arr.length - 1));
      str += arr[pos];
    }
    return str;
  }


  getSHA(str) {
    var obj = crypto.createHash('sha1');//与java的SHA加密方式生成的密钥相同
    obj.update(str);
    str = obj.digest('hex');//hex是十六进制
    return str;
  }

  async agentConfig() {
    return new Promise(async (r, e) => {
      try {
        var timestamp = parseInt((+ new Date()) / 1000)
        var nonceStr = this.randomWord(20, 20)
        var ticket = await this.post("users", "getJsApiTicket")
        var signature = this.getSHA(`jsapi_ticket=${ticket.ticket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${location.href.split("#/")[0]}`)
        console.log(`jsapi_ticket=${ticket.ticket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${location.href.split("#/")[0]}`)
        wx.agentConfig({
          grouid: ticket.grouid, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: ticket.agentid, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature,// 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList: ['selectExternalContact', "selectEnterpriseContact", "openAppManage", "selectCorpGroupContact", "openEnterpriseChat"], //必填，传入需要使用的接口名称
          success: function (res) {
            r(true)
          }, fail: function (res) {
            console.log("ERROR", res)
            r(false)
          }
        });
      } catch (e) {
        console.log(e)
        r(false)
      }
    })
  }

  select_user(mode, type, fromDepartmentId, selectedUserIds, selectedDepartmentIds) {

    return new Promise((r, e) => {
      wx.invoke("selectEnterpriseContact", {
          debug: false,
          "fromDepartmentId": fromDepartmentId,// 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          "mode": mode,// 必填，选择模式，single表示单选，multi表示多选
          "type": type,// 必填，选择限制类型，指定department、user中的一个或者多个
          "selectedDepartmentIds": selectedDepartmentIds || [],// 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          "selectedUserIds": selectedUserIds || [],// 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, async function (res) {

          if (res.err_msg == "selectEnterpriseContact:ok") {
            if (typeof res.result == 'string') {
              res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            r(res.result.userList)
          } else {
            r(false)
          }
        }
      );
    })
  }

  isPhone(phone) {
    var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!myreg.test(phone)) {
      return false;
    } else {
      return true;
    }
  }


  sort_data(data, value) {

    for (var i = 0; i < data.length; i ++) {

      if (data[i].value === value) {
        return data[i]
      }

    }

  }


  getMonthBetween(start, end) {


    var result = [];
    //使用传入参数的时间
    var startTime = new Date(start);
    var endTime = new Date(end);
    while (endTime - startTime >= 0) {
      let year = startTime.getFullYear();
      let month = startTime.getMonth();
      month = month < 9 ? '0' + (month + 1) : month + 1;
      let day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
      //加入数组
      result.push(year + "-" + month + "-" + day);
      //更新日期
      startTime.setDate(startTime.getDate() + 1);
    }
    return result;

  }
}

export default new Util()



// WEBPACK FOOTER //
// ./src/assets/js/util.js